import brandConfig from './brandConfig';
import currentVehicle from './currentVehicle';
import dealer from './dealer';
import financialCalculators from './financialCalculators';
import offerOptions from './offerOptions';
import offers from './offers';
import savedBuild from './savedBuild';
import specialOffers from './specialOffers';
import ui from './ui';
import vehicleListFilters from './vehicleListFilters';
import vehicles from './vehicles';
export default {
    brandConfig: brandConfig,
    vehicleListFilters: vehicleListFilters,
    currentVehicle: currentVehicle,
    vehicles: vehicles,
    dealer: dealer,
    ui: ui,
    financialCalculators: financialCalculators,
    offers: offers,
    offerOptions: offerOptions,
    savedBuild: savedBuild,
    specialOffers: specialOffers,
};
